const PubSub = {
  events: {},
  subscribe(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  },
  unsubscribe(event, callback) {
    if (!this.events[event]) return;
    this.events[event] = this.events[event].filter((cb) => cb !== callback);
  },
  publish(event, data) {
    if (!this.events[event]) return;
    this.events[event].forEach((callback) => callback(data));
  },

  // Add a new method for one-time subscriptions
  subscribeOnce: function (eventName, fn) {
    const onceFn = (...args) => {
      this.unsubscribe(eventName, onceFn);
      fn.apply(this, args);
    };
    this.subscribe(eventName, onceFn);
    return onceFn; // Return handler for manual cleanup if needed
  },
};

export default PubSub;
